
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 4.832l8.148-1.11.004 7.86-8.145.046L2 4.832zm8.144 7.655l.006 7.867-8.144-1.12v-6.8l8.138.053zm.988-8.91L21.936 2v9.482l-10.804.086V3.577zm10.806 8.984l-.002 9.44-10.804-1.526-.015-7.931 10.821.017z","fill":"#00ADEF"}})])
          )
        }
      }
    